/* eslint-disable indent */
import React from "react";
import styles from "../stylesERv2.module.scss";

export const BloqueCTable = ({
  modoCombinado,
  verUltimos12Meses,
  bloqueCCollapsed,
  setBloqueCCollapsed,
  gestionMensualesCombinados,
  ingresosGestionContenidosMensual,
  detalleGestionContenidosPorMes,
  showGestionContenidosModal,
  formatCurrency,
  formatPercentage,
  porcentajeSobreFacturacion,
  ytdIngresosGestionContenidos,
  getCostoGestionValue,
  calcularCostoSoftwareEstimado,
  verEnDolares,
  selectedYear,
  getDolarValue,
  localString,
  pais,
  puedeEditar,
  openSoftwareDSModalC,
  openEditGestion,
  ytdSoftwareDS,
  ytdOtros,
  margenGestionContenidosMensual,
  ytdMargenGestionContenidos,
  margenPorcentaje,
  monthsToShow,
  // Parte del costo de contenidos digitales imputada al circuito de cartelería (reparto
  // proporcional por pantallas; la otra pata vive en el Bloque A).
  contenidosDigitales = null,
  ytdContenidosDigitales = 0,
  // Handler de detalle { disponible, abrir } de la pata C de Contenidos Digitales (mismo
  // patrón que las celdas de costo del Bloque A). Solo lectura.
  onDetalleContenidosC = null,
}) => (
  <>
    {/* === BLOQUE C - Gestión & Contenidos === */}
    <tr
      className={styles.sectionHeader}
      onClick={() => !modoCombinado && setBloqueCCollapsed(!bloqueCCollapsed)}
      style={{ cursor: modoCombinado ? "default" : "pointer", userSelect: "none" }}
    >
      <td className={styles.conceptCell}>
        C - Gestión & Contenidos {!modoCombinado && !verUltimos12Meses && bloqueCCollapsed ? ">" : ""}
      </td>
      {(modoCombinado ? gestionMensualesCombinados : ingresosGestionContenidosMensual).map((val, i) => (
        <td
          key={i}
          className="text-end"
          style={{
            cursor:
              !modoCombinado && !verUltimos12Meses && i < monthsToShow && detalleGestionContenidosPorMes[i].length > 0
                ? "pointer"
                : "default",
          }}
          onClick={(e) => {
            e.stopPropagation();
            if (
              !modoCombinado &&
              !verUltimos12Meses &&
              i < monthsToShow &&
              detalleGestionContenidosPorMes[i].length > 0
            ) {
              showGestionContenidosModal(i);
            }
          }}
        >
          {i < monthsToShow ? formatCurrency(val, i, null, modoCombinado) : "-"}{" "}
        </td>
      ))}
      <td className={styles.totalCell}>
        {modoCombinado
          ? formatCurrency(
              gestionMensualesCombinados.slice(0, monthsToShow).reduce((a, b) => a + b, 0),
              null,
              null,
              true
            )
          : formatCurrency(ytdIngresosGestionContenidos, null, ingresosGestionContenidosMensual)}{" "}
        |{" "}
        {porcentajeSobreFacturacion(
          modoCombinado
            ? gestionMensualesCombinados.slice(0, monthsToShow).reduce((a, b) => a + b, 0)
            : ytdIngresosGestionContenidos
        )}
      </td>
    </tr>

    {!modoCombinado && !bloqueCCollapsed && (
      <>
        {/* Software DS */}
        <tr>
          <td className={styles.conceptCell}>Software DS</td>
          {Array.from({ length: 12 }, (_, i) => {
            const valorSupabase = getCostoGestionValue(i, "software_ds");
            // El v2 no tiene carga manual, asi que no hay celda "pendiente de cargar":
            // se conserva el VALOR (que cae al estimado de carteleria) pero SIN el
            // resaltado amarillo, que en el v1 marcaba justamente eso.
            const valorMostrado = valorSupabase > 0 ? valorSupabase : calcularCostoSoftwareEstimado(i);

            // Caso especial: modo USD → usar dólar día 1
            if (verEnDolares && i < monthsToShow) {
              const fechaDia1 = `${selectedYear}-${String(i + 1).padStart(2, "0")}-01`;
              const dolarDia1 = getDolarValue(fechaDia1);
              const valorUSD = dolarDia1 > 0 ? Math.round(valorMostrado / dolarDia1) : 0;
              const locale = localString(pais);
              const formatted = valorUSD.toLocaleString(locale, {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              });
              return (
                <td
                  key={i}
                  className="text-end"
                  style={{
                    cursor: puedeEditar ? "pointer" : "default",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (puedeEditar) openSoftwareDSModalC(i);
                  }}
                >
                  US$ {formatted}
                </td>
              );
            }

            return (
              <td
                key={i}
                className="text-end"
                style={{
                  cursor: i < monthsToShow && puedeEditar ? "pointer" : "default",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  if (i < monthsToShow && puedeEditar) openSoftwareDSModalC(i);
                }}
              >
                {i < monthsToShow ? formatCurrency(valorMostrado, i) : "-"}
              </td>
            );
          })}
          <td className={styles.totalCell}>
            {/* Caso especial YTD: Software DS en modo USD */}
            {verEnDolares
              ? (() => {
                  let totalUsd = 0;
                  for (let i = 0; i < monthsToShow; i++) {
                    const valorSupabase = getCostoGestionValue(i, "software_ds");
                    const valorMostrado = valorSupabase > 0 ? valorSupabase : calcularCostoSoftwareEstimado(i);
                    const fechaDia1 = `${selectedYear}-${String(i + 1).padStart(2, "0")}-01`;
                    const dolarDia1 = getDolarValue(fechaDia1);
                    if (valorMostrado > 0 && dolarDia1 > 0) {
                      totalUsd += valorMostrado / dolarDia1;
                    }
                  }
                  const locale = localString(pais);
                  const formatted = Math.round(totalUsd).toLocaleString(locale, {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  });
                  return `US$ ${formatted} | ${ytdIngresosGestionContenidos > 0 ? formatPercentage((ytdSoftwareDS / ytdIngresosGestionContenidos) * 100) : "0%"}`;
                })()
              : `${formatCurrency(
                  ytdSoftwareDS,
                  null,
                  Array.from(
                    { length: 12 },
                    (_, i) => getCostoGestionValue(i, "software_ds") || calcularCostoSoftwareEstimado(i)
                  )
                )} | ${ytdIngresosGestionContenidos > 0 ? formatPercentage((ytdSoftwareDS / ytdIngresosGestionContenidos) * 100) : "0%"}`}
          </td>
        </tr>
        {/* Otros */}
        <tr>
          <td className={styles.conceptCell}>Otros</td>
          {Array.from({ length: 12 }, (_, i) => {
            const valor = Number(getCostoGestionValue(i, "otros")) || 0;
            return (
              <td
                key={i}
                className="text-end"
                onClick={(e) => {
                  e.stopPropagation();
                  if (i < monthsToShow && puedeEditar) openEditGestion(i, "otros");
                }}
              >
                {i < monthsToShow ? formatCurrency(valor, i) : "-"}
              </td>
            );
          })}
          <td className={styles.totalCell}>
            {formatCurrency(
              ytdOtros,
              null,
              Array.from({ length: 12 }, (_, i) => getCostoGestionValue(i, "otros"))
            )}{" "}
            |{" "}
            {ytdIngresosGestionContenidos > 0
              ? formatPercentage((ytdOtros / ytdIngresosGestionContenidos) * 100)
              : "0%"}
          </td>
        </tr>
        {/* Contenidos Digitales — pata C del reparto por pantallas. Clickeable: el modal
            muestra las facturas + la línea de la parte publicidad (restando) para cuadrar
            con esta celda repartida. */}
        {contenidosDigitales && (
          <tr>
            <td className={styles.conceptCell}>Contenidos Digitales</td>
            {Array.from({ length: 12 }, (_, i) => {
              const clickable = Boolean(onDetalleContenidosC) && onDetalleContenidosC.disponible(i);
              return (
                <td
                  key={i}
                  className="text-end"
                  style={clickable ? { cursor: "pointer" } : undefined}
                  onClick={
                    clickable
                      ? (e) => {
                          e.stopPropagation();
                          onDetalleContenidosC.abrir(i);
                        }
                      : undefined
                  }
                >
                  {i < monthsToShow ? formatCurrency(contenidosDigitales[i] || 0, i) : "-"}
                </td>
              );
            })}
            <td className={styles.totalCell}>
              {formatCurrency(ytdContenidosDigitales, null, contenidosDigitales)} |{" "}
              {ytdIngresosGestionContenidos > 0
                ? formatPercentage((ytdContenidosDigitales / ytdIngresosGestionContenidos) * 100)
                : "0%"}
            </td>
          </tr>
        )}
        {/* Contribución C */}
        <tr className={styles.marginRow}>
          <td className={styles.conceptCellMargen}>Contribución</td>
          {margenGestionContenidosMensual.map((val, i) => (
            <td key={i} className="text-end">
              <div className={val < 0 ? styles.marginNegative : ""}>
                {i < monthsToShow ? formatCurrency(val, i) : "-"}
              </div>
            </td>
          ))}
          <td className={styles.totalCell}>
            <div className={ytdMargenGestionContenidos < 0 ? styles.marginNegative : ""}>
              {formatCurrency(ytdMargenGestionContenidos, null, margenGestionContenidosMensual)} |{" "}
              {margenPorcentaje(ytdMargenGestionContenidos, ytdIngresosGestionContenidos)}
            </div>
          </td>
        </tr>
      </>
    )}
  </>
);
